export const htmlSchema = {
	div: {
		attrs: {
			class: [
				'webtext-example',
				'webtext-callout',
				'webtext-callout-gutter',
				'webtext-pull-quote',
				'webtext-investigation-objective',
				'webtext-image-description',
				'webtext-excerpt-credits',
				'webtext-apa-reference-list',
				'webtext-article-source',
				'webtext-decoration',
				'webtext-objective',
				'webtext-placard',
				'webtext-source-attribution',
				'webtext-primary-source',
				'webtext-primary-source-attributes',
				'webtext-primary-source-content',

				'learning-objectives',

				'webtext-example webtext-decoration right',
				'webtext-example webtext-decoration wrong',
				'webtext-example webtext-decoration star',

				'webtext-callout unstyled',
				'webtext-callout webtext-callout-gutter quill',
				'webtext-callout webtext-callout-gutter scales-of-justice',
				'webtext-callout webtext-callout-gutter texas',
				'webtext-callout marker-icon document',
				'webtext-callout webtext-callout-gutter mobile-tip',
				'webtext-callout marker-icon scales-of-justice',

				'webtext-pull-quote tech-tip',

				'heading',
				'footnotes',
				'name',
				'title',
				'dateline',
				'byline',
				'subtitle',
				'blurb',
				'case-name',
				'case-number',
				'case-date',
				'case-appellate',
				'internal-heading',
				'artwork',
				'detail',
				'description',
				'glossary'
			],
			id: ['chapter-splash-description']
		}
	},
	em: { attrs: {} },
	iframe: {
		attrs: {
			src: [],
			frameborder: ['no'],
			name: [],
			width: [],
			height: [],
			scrolling: ['no'],
			allow: ['autoplay'],
			allowfullscreen: []
		}
	},
	img: {
		attrs: {
			alt: [],
			src: [],
			width: [],
			height: [],
			class: ['webtext-figure-asset', 'webtext-figure-asset-image']
		}
	},
	p: {
		attrs: {
			class: [
				'webtext-page-instruction',
				'webtext-image-caption',
				'webtext-time-estimate',
				'webtext-source-attribute',
				'webtext-source-title',
				'artist'
			],
			id: []
		}
	},
	span: {
		attrs: {
			'data-source-family-id': [],
			class: [
				'visually-hidden',

				'webtext-decoration',
				'webtext-figure-reference',
				'webtext-big-link-title',
				'webtext-big-link-credit',
				'webtext-source-url',
				'webtext-math',
				'webtext-pullquote-heading',
				'webtext-glossary-term-locations',
				'webtext-article-source-name',

				'wiley-link',
				'footnote-ref-tail',
				'icon-tech-tip',
				'keyterm-definition',
				'MsoHyperlink',
				'redactor-preserve-this',
				'rs_preserve',
				'sr-only'
			],
			style: [
				'padding-left: 1em',
				'padding-left: 2em',
				'padding-left: 4em',
				'padding-left: 10em',
				'padding-left: 20em',
				'padding-left: 40px'
			]
		}
	},
	strong: {
		attrs: {
			class: ['cnx-underline']
		}
	},
	style: {
		attrs: {
			type: ['text/css']
		}
	}
};
